import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function CrmClientes() {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/clientes")
            .then((r) => setClientes(r.data))
            .catch((err) => toast.error(formatApiError(err)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="space-y-10">
            <header>
                <p className="font-body uppercase tracking-[0.3em] text-xs text-dorado mb-3">
                    Clientes
                </p>
                <h1 className="font-heading text-5xl text-crema font-light">Base de clientes</h1>
            </header>

            {loading ? (
                <p className="text-piedra italic font-body">Cargando...</p>
            ) : clientes.length === 0 ? (
                <p className="text-piedra italic font-body">Aún no hay clientes registrados.</p>
            ) : (
                <div className="border border-dorado/20 bg-carbon-suave/40 divide-y divide-dorado/10">
                    {clientes.map((c) => (
                        <Link
                            key={c.id}
                            to={`/crm/clientes/${c.id}`}
                            className="block px-5 py-4 grid grid-cols-1 md:grid-cols-4 gap-3 items-center hover:bg-carbon transition-colors"
                            data-testid="crm-cliente-row"
                        >
                            <p className="font-heading text-lg text-crema">{c.nombre}</p>
                            <p className="font-body text-sm text-piedra">{c.email || "—"}</p>
                            <p className="font-body text-sm text-piedra">{c.telefono || "—"}</p>
                            <p className="font-body text-xs text-piedra/70">
                                {new Date(c.creado_en).toLocaleDateString("es-ES")}
                            </p>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
